<h1 mat-dialog-title>{{ receiver?.id ? "Edit" : "Add" }} {{ description }}</h1>
<form [formGroup]="form" (ngSubmit)="saveReceiver()">
    <mat-dialog-content>
        <p>
            <mat-form-field appearance="outline">
                <mat-label>Communication Type</mat-label>
                <select
                    matNativeControl
                    id="receiverType"
                    formControlName="receiverType"
                    placeholder="-- Select Communication type --"
                    required
                    [errorStateMatcher]="errorMatcher"
                >
                    <option *ngFor="let type of rcvTypes" [value]="type.value">{{ type.name }}</option>
                </select>
            </mat-form-field>
        </p>
        <p></p>
        <div *ngFor="let field of fields">
            <p *letVar="receiverFields.path as formfield">
                <mat-form-field appearance="outline" [ngClass]="{ hideField: !shouldShowField(field) }">
                    <mat-label>{{ field.label }}</mat-label>
                    <input
                        matInput
                        [id]="field.controlName"
                        [type]="getFieldType(field)"
                        [formControlName]="field.controlName"
                        placeholder="{{ field.label }}"
                        [errorStateMatcher]="errorMatcher"
                        (input)="field.inputMethod ? field.inputMethod(field.controlName) : null"
                        (blur)="field.blurMethod ? field.blurMethod(field.controlName) : null"
                    />
                    <mat-error>
                        <app-validation-message [touched]="formfield.touched" [errors]="formfield.errors"></app-validation-message>
                    </mat-error>
                </mat-form-field>
            </p>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions class="formActionButtonGroup mat-dialog-actions clearfix">
        <div class="input-action-container">
            <a *ngIf="!receiverFields?.id?.value; else removeReceiver" mat-stroked-button id="cancel" (click)="cancel()"> Nevermind </a>
            <ng-template #removeReceiver
                ><button mat-raised-button color="warn" (click)="removeIpReceiver()" class="remove-ip-receiver">Remove</button>
            </ng-template>

            <button
                mat-raised-button
                color="primary"
                class="new-primary-button"
                [disabled]="!checkFormValid"
                type="submit"
                class="save-ip-receiver"
            >
                Save
            </button>
        </div>
    </mat-dialog-actions>
</form>
